import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {VoucherGenRepository} from '../repositories/voucher-gen.repository';

@Injectable()
export class VoucherGenService {

  constructor(private voucherGenRepository: VoucherGenRepository) { }

  public createVoucher(amount: number): Observable<Blob> {
    return this.voucherGenRepository.generateVouchers(amount);
  }

  public validateCode(code: string): Observable<boolean> {
    return this.voucherGenRepository.validateCode(code);
  }

  public invalidateCode(code: string): Observable<string> {
    return this.voucherGenRepository.invalidateCode(code);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-gen/services/voucher-gen.service.ts